import { simple_pair_range } from "./index.js";
import { plane_angle_measure } from "./index.js";
import { unlimited_rangeDeserializeStep } from "./index.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
///**
// *  */
export class universal_pair_range extends simple_pair_range {
    get type() {
        return EntityTypesAP214.UNIVERSAL_PAIR_RANGE;
    }
    get lower_limit_first_rotation() {
        if (this.lower_limit_first_rotation_ === void 0) {
            const enumValue = this.extractLambda(2, unlimited_rangeDeserializeStep, true);
            const value = enumValue ??
                this.extractReference(2, false);
            if (enumValue === null && !(value instanceof plane_angle_measure)) {
                throw new Error("Value in STEP was incorrectly typed for field");
            }
            this.lower_limit_first_rotation_ = value;
        }
        return this.lower_limit_first_rotation_;
    }
    get upper_limit_first_rotation() {
        if (this.upper_limit_first_rotation_ === void 0) {
            const enumValue = this.extractLambda(3, unlimited_rangeDeserializeStep, true);
            const value = enumValue ??
                this.extractReference(3, false);
            if (enumValue === null && !(value instanceof plane_angle_measure)) {
                throw new Error("Value in STEP was incorrectly typed for field");
            }
            this.upper_limit_first_rotation_ = value;
        }
        return this.upper_limit_first_rotation_;
    }
    get lower_limit_second_rotation() {
        if (this.lower_limit_second_rotation_ === void 0) {
            const enumValue = this.extractLambda(4, unlimited_rangeDeserializeStep, true);
            const value = enumValue ??
                this.extractReference(4, false);
            if (enumValue === null && !(value instanceof plane_angle_measure)) {
                throw new Error("Value in STEP was incorrectly typed for field");
            }
            this.lower_limit_second_rotation_ = value;
        }
        return this.lower_limit_second_rotation_;
    }
    get upper_limit_second_rotation() {
        if (this.upper_limit_second_rotation_ === void 0) {
            const enumValue = this.extractLambda(5, unlimited_rangeDeserializeStep, true);
            const value = enumValue ??
                this.extractReference(5, false);
            if (enumValue === null && !(value instanceof plane_angle_measure)) {
                throw new Error("Value in STEP was incorrectly typed for field");
            }
            this.upper_limit_second_rotation_ = value;
        }
        return this.upper_limit_second_rotation_;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
universal_pair_range.query = [EntityTypesAP214.UNIVERSAL_PAIR_RANGE];
universal_pair_range.expectedType = EntityTypesAP214.UNIVERSAL_PAIR_RANGE;
